import { ApiErrorEvent, ErrorEvent } from '@unive/analytics';

export function mapErrorEvent(event: ErrorEvent): ApiErrorEvent {
  return {
    foutmelding: {
      bericht: event.message,
      type: event.type,
      ...(!!event.code && { code: event.code }),
      ...(!!event.context && { context: event.context }),
    },
  };
}
